<template lang="pug">
  #faq-list(v-cloak)
    .box
      .box-header.with-border.register-header
        .title
          span よくある質問
        .buttons
          button.btn.back-btn(@click="gotoSupportList()" type="button") 戻る
      .box-body
        .faq-card
          b-card(no-body)
            b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-1)
              span.toggle-text 【基本】HitomeQコネクトとは何ですか？
            b-collapse(id="accordion-1" accordion="my-accordion1" role="tabpanel")
              b-card-body
                .panel-body
                  p.bold 施設と、利用者ご家族、職員、関係者（ケアマネ等）とのコミュニケーションツールです。
                  p ご家族等にメッセージ・写真・動画・文書を送ることができ、ご家族等はスマートフォンのLINEで確認することが出来ます。
                  p 連絡を送るだけでなく、アンケート、職員の安否確認、ケアマネへの空床情報の提供など、豊富な機能があります。
                  table
                    thead
                      tr
                        th.function-name 特徴
                        th.details 説明
                    tbody
                      tr
                        td.function-name LINEアプリ
                        td.details
                          div ご家族、職員、関係者（ケアマネ等）は使い慣れたLINEアプリを使用
                          div 用意されたメニューを選択するだけ
                          div ご家族等はLINEプロフィールを施設に知られずに使用可能
                      tr
                        td.function-name 特別な機器不要
                        td.details
                          div 施設向けアプリはインターネットに接続可能なパソコンがあれば使用可能
                          div アプリをインストールすることなく、パソコンでもiPadでもスマートフォンでも使用可能
                          div クラウドアプリなので、同時に複数人・複数の機器から使用可能
                      tr
                        td.function-name 介護施設向け
                        td.details
                          div 介護施設向けに開発したアプリなので、使い方も簡単
                          div オンライン面会の予約管理設定も、介護施設の運用に合わせた設定が可能
                      tr
                        td.function-name 豊富な機能
                        td.details
                          div 連絡機能だけでなく、安否確認、空室情報提供など介護施設向けの豊富な機能があります。
                          div 使用機能に応じたプラン選択と、施設ごとの使用機能の設定ができます。

        .faq-card
          b-card(no-body)
            b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-2)
              span.toggle-text 【基本】ご家族はどんな機能を使用できますか？
            b-collapse(id="accordion-2" accordion="my-accordion2" role="tabpanel")
              b-card-body
                .panel-body
                  p LINEから下記の機能を使用することが出来ます。
                  p ご家族が使用できる機能を施設側で設定できます（プランによっては使用できない機能があります）。
                  table.table
                    thead
                      tr
                        th.function-name 機能名
                        th.details 説明
                    tbody
                      tr
                        td.function-name メッセージ
                        td.details
                          div 施設やHitomeQコネクトへのお問い合わせ・連絡を送ることができ、その内容の確認もできます。
                          div また、施設から送付したメッセージへの返信、返信したメッセージの確認もできます。
                      tr
                        td.function-name 面会予約
                        td.details
                          div 簡単な操作で訪問面会とオンライン面会の予約、確認が可能です。
                          div 予約完了時と面会前日に、ご家族のLINEに予約案内を送ります。
                          div オンライン面会のビデオ通話はご家族4人まで同時に参加できます。
                      tr
                        td.function-name 写真印刷依頼
                        td.details
                          div ご家族の写真を簡単に施設スタッフに送付できます。
                          div 写真データを施設内のプリンタで印刷し、利用者様にお渡ししていただけます。
                      tr
                        td.function-name イベント情報
                        td.details
                          div 施設で開催されるイベント情報を確認できます。
                          div イベントの参加申込み、オンライン参加（ライブ配信）ができます。
                      tr
                        td.function-name 介護記録
                        td.details 
                          div 公開されている最新の介護記録を画像で表示します。
                          div 介護記録はスマートフォンに保存できます。
                      tr
                        td.function-name 施設情報
                        td.details
                          div 施設の所在地や電話番号などをすぐに確認できます。
                      tr
                        td.function-name 設定変更
                        td.details
                          div ユーザー登録情報の変更・削除ができます。
                          div よくある質問の確認、コニカミノルタへの問い合わせができます。
        .faq-card
          b-card(no-body)
            b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-3)
              span.toggle-text 【登録】ご家族への案内・ユーザー登録はどうしたらいいですか？
            b-collapse(id="accordion-3" accordion="my-accordion3" role="tabpanel")
              b-card-body
                .panel-body
                  p.bold スマートフォンをお持ちのご家族
                  p ・ご家族はご自身でスマートフォンのLINEアプリからユーザー登録できます。
                  p ・マニュアルの「ご家族説明用 サービスご紹介」と「ご家族説明用 HitomeQコネクト登録方法」、利用者画面から印刷できる「ID通知書」をご家族にお渡しください。
                  p ・ご家族がユーザー登録すると、利用者画面の家族ユーザーもしくは家族ユーザー画面でご確認いただけます。
                  p.bold スマートフォンをお持ちでないご家族
                  p ・家族ユーザー画面の「メール利用の家族を追加」からご家族のメールアドレスをご登録できます。
                  p ・その際はマニュアルの「ご家族用利用規約」をご家族にお渡しください。
                  p ・「ご家族用メール配信申込書サンプル」をお使いいただくこともできます。
        .faq-card
          b-card(no-body)
            b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-4)
              span.toggle-text 【登録】ご家族は何人まで登録可能ですか？
            b-collapse(id="accordion-4" accordion="my-accordion4" role="tabpanel")
              b-card-body
                .panel-body
                  p ご家族の登録人数に制限はありません。
                  p 同じご利用者のご家族は同じIDとパスワードでご登録いただけます。
                  p ご家族は複数のご利用者を登録できます。その場合、各ご利用者のID通知書をお渡しください。
        .faq-card
          b-card(no-body)
            b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-5)
              span.toggle-text 【登録】メール利用のご家族は何ができますか？
            b-collapse(id="accordion-5" accordion="my-accordion5" role="tabpanel")
              b-card-body
                .panel-body
                  p メール利用のご家族に、メッセージ送信機能を使用してお知らせを送ることができます。
                  p 施設からのメッセージ送信機能以外にも、文書送付・アンケート・安否情報提供を送ることができますが、介護記録・写真印刷依頼・イベント情報・家族からの連絡・面会予約・オンライン面会は使用できません。
                  p 面会予約は施設側で代理予約することができます。代理予約時の予約案内をメールにお送りします。
        .faq-card
          b-card(no-body)
            b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-6)
              span.toggle-text 【機器】動作環境（デバイス、OS、ディスプレイ、ブラウザ）を教えてください。
            b-collapse(id="accordion-6" accordion="my-accordion6" role="tabpanel")
              b-card-body
                .panel-body
                  p.bold 施設向けアプリの動作環境
                  p ・WindowsパソコンのChromeブラウザ（最新バージョン推奨） ※ ディスプレイ解像度の推奨は、1920x1080の125%
                  p ・iPadもしくはiPhoneのSafariブラウザ（最新バージョン推奨）
                  p ・AndroidスマートフォンのChromeブラウザ（最新バージョン推奨）
                  p ・スマートフォン（iPhone, Android）はスマートフォン版の施設向けアプリを表示します。※ 機能制限があります
                  p.bold ご家族向けLINEアプリの動作環境
                  p ・iPhone（iOS13以降）もしくはAndroid（7.0以降）スマートフォンです。
                  p ・オンライン面会機能は、iOS13以降のSafariもしくはChromeブラウザ、Android7.0以降のChromeブラウザです。
                  p ・イベントのオンライン参加は、iOS13以降のSafariブラウザ、Android7.0以降のChromeブラウザ最新版です。
        .faq-card
          b-card(no-body)
            b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-7)
              span.toggle-text 【機器】複数の機器から同時に使用できますか？
            b-collapse(id="accordion-7" accordion="my-accordion7" role="tabpanel")
              b-card-body
                .panel-body
                  p 複数の機器から同時に使用できます。
                  p オンライン面会も複数の面会を同時に実施することができます。
                  p 管理者ユーザーの他に一般ユーザーを追加すると、複数のログインユーザーを使用することができます。
                  p 一般ユーザーは、管理者ユーザーが使用機能や閲覧可能利用者グループ等を設定することができます。
                  p 一般ユーザーの追加は、お問い合わせからご依頼ください。
        .faq-card
          b-card(no-body)
            b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-8)
              span.toggle-text 【機器】スマートフォン版の施設向けアプリは何が出来ますか？
            b-collapse(id="accordion-8" accordion="my-accordion8" role="tabpanel")
              b-card-body
                .panel-body
                  p 以下の機能を使用できます。
                  p ・メッセージの新規送信、送信履歴と返信の確認
                  p ・受信メッセージの確認と返信
                  p ・面会予約の確認と予約・面会の操作（予約承諾・予約辞退・予約キャンセル・面会開始）
                  p ・安否確認の施設関係者向けの事前設定と安否入力依頼の送信
        .faq-card
          b-card(no-body)
            b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-9)
              span.toggle-text 【機能】ご家族から「オンライン面会が出来ない」と問い合わせがあった場合、どうしたら良いですか？
            b-collapse(id="accordion-9" accordion="my-accordion9" role="tabpanel")
              b-card-body
                .panel-body
                  p ご家族はご家族向けLINEアプリの面会予約メニューから「オンライン面会の使い方」をご確認いただけます。
                  p まずはこちらをご確認いただきますようにご案内ください。
                  a(href="/docs/online-meeting-manual/index.html" target="_blank") ご家族向けオンライン面会の使い方
        .faq-card
          b-card(no-body)
            b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-10)
              span.toggle-text 【機能】イベントのオンライン開催（ライブ配信）は何ができますか？
            b-collapse(id="accordion-10" accordion="my-accordion10" role="tabpanel")
              b-card-body
                .panel-body
                  p イベント当日に、施設からご家族に向けてイベント映像をライブ配信することができます（月に1回のみ）。
                  p ライブ配信の開始は、パソコンもしくはiPadからイベント情報画面の「配信開始」を押してください。
                  p イベント当日以前でも「配信開始」を押せますので、事前にご確認ください（ただしご家族は参加できません）。
                  p ご家族はご家族向けLINEアプリのイベント情報メニューから「参加申込・参加の方法」をご確認いただけます。
                  a(href="/docs/online-event-manual/index.html" target="_blank") ご家族向けイベント参加申込み・オンライン参加の方法
        .faq-card
          b-card(no-body)
            b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-11)
              span.toggle-text 【機能】安否確認は何ができますか？
            b-collapse(id="accordion-11" accordion="my-accordion11" role="tabpanel")
              b-card-body
                .panel-body
                  p 職員様などの安否確認と、ご家族への安否情報提供ができます。
                  p 施設関係者に登録されている職員様のLINEに、確認したい安否確認項目の質問を配信し、回答を集計することができます。
                  p 登録されているご家族のLINEに、施設状況やご利用者の個別状況を情報提供することができます。
                  p 災害時は電話が繋がりにくくなりますが、LINE等のアプリは比較的使用することができます。
                  p まずは職員様とご家族のご登録、安否確認の事前設定をしてご準備ください。
        .faq-card
          b-card(no-body)
            b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-12)
              span.toggle-text 【機能】空床スケジュールは何ができますか？
            b-collapse(id="accordion-12" accordion="my-accordion12" role="tabpanel")
              b-card-body
                .panel-body
                  p ご利用者の入退所日を登録するだけで、部屋スケジュールを自動作成します。
                  p 転床や仮押さえの登録も出来ますので、ショートステイ等のスケジュール管理にも使えます。
                  p 部屋スケジュールを基に空室／空床情報を自動作成します。それをケアマネ等に公開することができます。
                  p 空室／空床情報を公開するケアマネ等は、施設関係者ユーザーとしてLINEから登録してもらってください。
                  p 空室／空床情報の公開ユーザーや公開設定（公開日等）も設定することができます。
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

import { PcUrl } from "@/commons/constants/PcUrl";

/**
 * FAQ画面コンポーネント
 */
@Component
export default class FaqList extends Vue {
  /**
   * vue lifecycle created
   */
  private async created(): Promise<void> {
    return;
  }

  /**
   * 問い合わせ一覧画面へ遷移する
   */
  private gotoSupportList(): void {
    this.$router.push(PcUrl.SupportList);

    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

// 親要素からネストしてスタイルを指定する
#faq-list {
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;
  .box {
    .faq-card {
      margin-bottom: 20px;

      p {
        margin-bottom: 10px !important;
        &.bold {
          font-weight: bold;
        }
      }

      table {
        @include default-table(800px);
        th,
        td {
          &.function-name {
            // 全角7文字が表示できる幅
            width: 140px;
            text-align: center;
          }
          &.details {
            // 全角36文字が表示できる幅
            width: 740px;
          }
        }
      }
    }
  }
}
</style>
